import React from "react";

import { CR_CRITERIA_HEADER, CR_CRITERIA_MESSAGE } from "src/web/constants";

export const CrCriteriaSection: React.FC = () => (
    <>
        <h4>{CR_CRITERIA_HEADER}</h4>
        <p>{CR_CRITERIA_MESSAGE}</p>
    </>
);

export default CrCriteriaSection;
